import { render, staticRenderFns } from "./CircularLoader.vue?vue&type=template&id=99f4b37a"
var script = {}
import style0 from "./CircularLoader.vue?vue&type=style&index=0&id=99f4b37a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports